export const loginObjData=(email,password)=>{
    const loginFormData = new FormData();
    loginFormData.append('email', email);
    loginFormData.append('password', password);
    loginFormData.append('password_confirmation', password);
    return loginFormData;
}
export const loginStuffObjData=(email,password)=>{
    const loginFormData = new FormData();
    loginFormData.append('email', email);
    loginFormData.append('password', password);
    return loginFormData;
}

export const isOk=(status)=>{
    return status>199 && status<230;
}

export const getToken=()=>{
    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.token || false;
    return token??false;
}

